import useSWRImmutable from 'swr/immutable'
import {useRails} from '~/react/contexts/rails'
import {fetcher} from '~/api'

export const useTermsPdf = (pauseFetch = false) => {
  const {
    organisation: {currentSupplier},
  } = useRails()

  const supplierId = currentSupplier?.id
  // If pauseFetch is true, the fetch will be delayed until the pauseFetch changes to false
  // This is used to delay the fetch until we are ready for example when a modal is opened.
  const url =
    !pauseFetch && supplierId
      ? `/points/api/suppliers/${supplierId}/terms_acceptance`
      : null

  const {data, isLoading} = useSWRImmutable(url, fetcher, {
    revalidateOnFocus: false,
  })

  const {pdf} = data || {}

  return {
    pdf,
    isLoading,
  }
}
